import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import locationSvg from "../../assets/meeting/location.svg";
import cameraSvg from "../../assets/meeting/camera.svg";
import joinSvg from "../../assets/meeting/join-meeting.svg";
import descriptionSvg from "../../assets/meeting/description.svg";
import Guests from "./Guests";
import { extractMeetingUrl, parseText } from "../../utils/utils";
import "../../styles/common.css";

interface MeetingProps {
  meeting: any | null;
  isInteractionAttendee?: boolean;
}

const Meeting: React.FC<MeetingProps> = ({ meeting, isInteractionAttendee }) => {
  const theme = useTheme();

  const meetingLink = extractMeetingUrl({
    meetingLink: meeting?.joinLink,
    description: meeting?.description,
    botStatusMessage: meeting?.botStatusMessage,
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "64px",
        paddingTop: "20px",
        [theme.breakpoints.down("lg")]: {
          gap: "32px",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "20px",
          [theme.breakpoints.down("lg")]: {
            gap: "18px",
          },
          width: "100%",
        }}
      >
        {/* Guests list */}
        <Box className="meeting-guests-container">
          <Guests
            meetingId={meeting?.id}
            attendees={meeting?.attendees}
            organizer={meeting?.organizer}
            attendedParticipants={meeting?.attendedParticipants}
          />
        </Box>

        {/* Other info */}
        <div className="meeting-info-container">
          <div className="meeting-heading-part">
          <Typography className="meeting-info-heading">
              <span>Other Information :</span>

          </Typography>
          </div>

          {/* Location */}
          <div className="meeting-row">
            <div className="meeting-icon-box">
              <img src={locationSvg} style={{ width: "20px", height: "20px" }} className={`${!isInteractionAttendee ? "disabled-link" : ""}`} />
            </div>
            {meeting?.location ? (
              <Typography
              className={`meeting-link ${!isInteractionAttendee ? "disabled-link" : ""}`}
              onClick={
                isInteractionAttendee
                  ? () => window.open(meeting.location, "_blank")
                  : undefined
              }
              sx={{
                cursor: isInteractionAttendee ? "pointer" : "default",
                userSelect: isInteractionAttendee ? "text" : "none",
              }}
              >
                {meeting.location}
              </Typography>
            ) : (
              <Typography className="meeting-text">No location specified</Typography>
            )}
          </div>

          {/* Join Link */}
          <div className="meeting-row">
            <div className="meeting-icon-box">
              <img src={cameraSvg} className={`${!isInteractionAttendee ? "disabled-link" : ""}`} style={{ width: "20px", height: "20px" }} />
            </div>
            {meetingLink && meeting?.joinLink ? (
              <>
                <Typography
                  className={`meeting-link ${!isInteractionAttendee ? "disabled-link" : ""}`}
                  onClick={
                    isInteractionAttendee
                      ? () => window.open(meetingLink.url, "_blank")
                      : undefined
                  }
                  sx={{
                    cursor: isInteractionAttendee ? "pointer" : "default",
                    userSelect: isInteractionAttendee ? "text" : "none",
                  }}
                >
                  {meetingLink.text}
                </Typography>
                <img src={joinSvg} style={{ width: "12px", height: "12px" }} />
              </>
            ) : (
              <Typography className="meeting-text">No interaction link specified</Typography>
            )}
          </div>

          {/* Description */}
          <div className="meeting-row">
            <div className="meeting-icon-box">
              <img src={descriptionSvg} style={{ width: "20px", height: "20px" }} className={`${!isInteractionAttendee ? "disabled-link" : ""}`} />
            </div>
            {meeting?.description ? (
              <Typography className={`meeting-description ${!isInteractionAttendee ? "disabled-link" : ""}`}
              sx={{
                cursor: isInteractionAttendee ? "pointer" : "default",
                userSelect: isInteractionAttendee ? "text" : "none",
              }}>
                {parseText(meeting?.description)}
              </Typography>
            ) : (
              <Typography className="meeting-text">No description specified</Typography>
            )}
          </div>
        </div>

        {/* Empty space to maintain layout */}
        <div style={{ width: "30%" }}></div>
      </div>
    </div>
  );
};

export default Meeting;
